import React from 'react';
import ToolBar from './toolbar';
import ScheduleList from './schedules-table';
import AddSchedule from './add-schedule';

const ScheduleView = (props) => {

  let {
     displayMissionDetail, slots, schedules ,appointments, date, onNext, onPrevious, doctors,
     schedule_start, schedule_end, submitSchedule, onChange, operatingHours, selectedDoctor, 
     onSelectDoctor, showSchedulesOpen, toggleShowSchedulesOpen, deleteSchedule, 
     clickedDoctor, clickedSlot, setSlotWithDoctor, scheduleId, setScheduleId
    } = props;

  return (
    <div style={{height:'40%'}}>
      <ToolBar
        date={date}
        onNext={onNext}
        onPrevious={onPrevious}
      />
      <AddSchedule
        schedule_start={schedule_start}
        schedule_end={schedule_end}
        submitSchedule={submitSchedule}
        onChange={onChange}
        operatingHours={operatingHours}
        selectedDoctor={selectedDoctor}
        onSelectDoctor={onSelectDoctor}
        doctors={doctors}
      />
      <ScheduleList
        slots={slots}
        schedules={schedules}
        appointments={appointments}
        displayMissionDetail={displayMissionDetail}
        showSchedulesOpen={showSchedulesOpen}
        toggleShowSchedulesOpen={toggleShowSchedulesOpen}
        deleteSchedule={deleteSchedule}
        clickedDoctor={clickedDoctor}
        clickedSlot={clickedSlot}
        setSlotWithDoctor={setSlotWithDoctor}
        scheduleId={scheduleId}
        setScheduleId={setScheduleId}
      />
    </div>
  )
};

export default ScheduleView;


// WEBPACK FOOTER //
// ./src/screens/schedules/index.js